import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams,useLocation, useNavigate } from "react-router-dom";
import { getRegistration, getRegisterUser, message, register, getSubsite, confirm } from '../reducers/auth';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const ConfirmEmail = (props) => {
  let navigate = useNavigate();
  const form = useRef();
  const checkBtn = useRef();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [successful, setSuccessful] = useState(false);
  const theMessage = useSelector(message);
  const registerUser = useSelector(getRegisterUser);
  let [searchParams, setSearchParams] = useSearchParams();
  const currentSubsite = useSelector(getSubsite);

  const dispatch = useDispatch();
  const location = useLocation();
  
  useEffect(() => {
    if(searchParams.get("id")) {
        dispatch(confirm(searchParams.get("id")));
    }
  }, []);

  return (
    <div className="container">
          <p>Thank you for Registering with Ignite Gear.</p>
            <p>
                Your registration is complete.  You may now login to the site.
                Login <a href="/login">here</a>
            </p>
    </div>
  );
};
export default ConfirmEmail;